export default (function () {
  if ($('.slider .articles_block--slider .item').length < 3) {} else {
    $('.slider .articles_block--slider').not('.slick-initialized').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      responsive: [{
        breakpoint: 800,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          variableWidth: true
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerMode: true
        }
      }]
    });
  }

  $('.project .slider_mob').not('.slick-initialized').each(function () {
    var dotsOnMobile = $(this).parents(".project").data('dots_on_mobile');
    $(this).slick({
      dots: false,
      arrows: false,
      infinite: false,
      variableWidth: true,
      speed: 300,
      slidesToShow: 7,
      slidesToScroll: 1,
      draggable: true,
      swipe: true,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          dots: dotsOnMobile
        }
      }]
    });
  });
  $(".page-slider_2, .certificates").not('.slick-initialized').on("init", function (event, slick) {
    var totalNumber = n(slick.slideCount);
    var currentNumber = n(parseInt(slick.currentSlide + 1));

    if (totalNumber !== '01' && $(this).find(".counter").length < 1) {
      // $(this).parents(".slick-wrapper").append("<div class='counter'><span class='current'>" + currentNumber + "</span> / <span class='total'>" + totalNumber + "</span></div>")
      $(this).parents(".slick-wrapper").find(".counter-controls__counter").html('<span class="current">' + currentNumber + '</span> / <span class="total">' + totalNumber);
    }
  });
  $(".page-slider_2, .certificates").not('.slick-initialized').on("afterChange", function (event, slick, currentSlide, nextSlide) {
    var totalNumber = n(slick.slideCount);
    var currentNumber = n(parseInt(slick.currentSlide + 1)); // $(this).parents(".slick-wrapper").find(".counter").html('<span class="current">' + currentNumber + '</span> / <span class="total">' + totalNumber);

    $(this).parents(".slick-wrapper").find(".counter-controls__counter").html('<span class="current">' + currentNumber + '</span> / <span class="total">' + totalNumber);
  }); // adding "0" to single number

  function n(n) {
    return n > 9 ? "" + n : "0" + n;
  }

  $('.page-slider_2').not('.slick-initialized').each(function () {
    var autoplaySettings;

    if ($(this).parents(".slider-block").data('autoplay')) {
      autoplaySettings = $(this).parents(".slider-block").data('autoplay');
    } else {
      autoplaySettings = false;
    }

    if ($(this).parents(".slider-block").hasClass('slider-block--two_slides')) {
      $(this).slick({
        dots: false,
        arrows: true,
        infinite: true,
        // adaptiveHeight: false,
        slidesToShow: 2,
        // variableWidth: true,
        slidesToScroll: 1,
        autoplay: autoplaySettings,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + ' <g transform="translate(-1459.586 -1193.293)">\n' + ' <path d="M9583,14637l-5,5,5,5" transform="translate(-8117 -13443)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' <line x2="19" transform="translate(1461 1199)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' </g>\n' + '</svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + '  <g transform="translate(-1580 -1193.293)">\n' + '  <path d="M9583,14637l-5,5,5,5" transform="translate(11177 15841) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  <line id="Line_94" x2="19" transform="translate(1599 1199) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  </g>\n' + '</svg></button>',
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            variableWidth: false
          }
        }]
      });
    } else {
      $(this).slick({
        dots: false,
        arrows: true,
        infinite: false,
        // adaptiveHeight: false,
        // slidesToShow: 2,
        variableWidth: true,
        slidesToScroll: 1,
        autoplay: autoplaySettings,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + ' <g transform="translate(-1459.586 -1193.293)">\n' + ' <path d="M9583,14637l-5,5,5,5" transform="translate(-8117 -13443)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' <line x2="19" transform="translate(1461 1199)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' </g>\n' + '</svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + '  <g transform="translate(-1580 -1193.293)">\n' + '  <path d="M9583,14637l-5,5,5,5" transform="translate(11177 15841) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  <line id="Line_94" x2="19" transform="translate(1599 1199) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  </g>\n' + '</svg></button>',
        responsive: [{
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            variableWidth: true
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            variableWidth: false
          }
        }]
      });
    }
  });
  $('.certificates').not('.slick-initialized').each(function () {
    var dotsOnMobile = $(this).parents(".wins").data('dots_on_mobile');
    var dotsOnTablet = $(this).parents(".wins").data('dots_on_tablet');

    if ($(this).find('.items').length < 5) {
      $(this).slick({
        dots: false,
        arrows: true,
        infinite: true,
        // variableWidth: true,
        centerMode: true,
        speed: 300,
        slidesToShow: 4,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            dots: dotsOnTablet
          }
        }, {
          breakpoint: 800,
          settings: {
            variableWidth: true,
            slidesToShow: 3
          }
        }, {
          breakpoint: 600,
          settings: {
            variableWidth: true,
            slidesToShow: 3,
            dots: dotsOnMobile
          }
        }]
      });
    } else {
      var autoplaySettings = $(this).parents(".wins").data('autoplay');

      if ($(this).parents(".wins").hasClass('wins--in_container')) {
        $(this).slick({
          dots: false,
          arrows: true,
          infinite: true,
          centerMode: true,
          speed: 300,
          slidesToShow: 3,
          autoplay: autoplaySettings,
          // autoplaySpeed:1500,
          prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + ' <g transform="translate(-1459.586 -1193.293)">\n' + ' <path d="M9583,14637l-5,5,5,5" transform="translate(-8117 -13443)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' <line x2="19" transform="translate(1461 1199)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' </g>\n' + '</svg></button>',
          nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + '  <g transform="translate(-1580 -1193.293)">\n' + '  <path d="M9583,14637l-5,5,5,5" transform="translate(11177 15841) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  <line id="Line_94" x2="19" transform="translate(1599 1199) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  </g>\n' + '</svg></button>',
          responsive: [{
            breakpoint: 1024,
            settings: {
              dots: dotsOnTablet
            }
          }, {
            breakpoint: 600,
            settings: {
              dots: dotsOnMobile,
              slidesToShow: 2
            }
          }]
        });
      } else {
        $(this).slick({
          dots: false,
          arrows: true,
          infinite: true,
          variableWidth: true,
          centerMode: true,
          speed: 300,
          // slidesToShow: 5,
          autoplay: autoplaySettings,
          // autoplaySpeed:1500,
          prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + ' <g transform="translate(-1459.586 -1193.293)">\n' + ' <path d="M9583,14637l-5,5,5,5" transform="translate(-8117 -13443)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' <line x2="19" transform="translate(1461 1199)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' </g>\n' + '</svg></button>',
          nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + '  <g transform="translate(-1580 -1193.293)">\n' + '  <path d="M9583,14637l-5,5,5,5" transform="translate(11177 15841) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  <line id="Line_94" x2="19" transform="translate(1599 1199) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  </g>\n' + '</svg></button>',
          responsive: [{
            breakpoint: 1024,
            settings: {
              dots: dotsOnTablet
            }
          }, {
            breakpoint: 600,
            settings: {
              dots: dotsOnMobile
            }
          }]
        });
      }
    }
  });
  $(".post_slider .slide-left").click(function () {
    $(this).parent('.post_slider').find('.slick-prev').click();
  });
  $(".post_slider .slide-right").click(function () {
    $(this).parent('.post_slider').find('.slick-next').click();
  });
  $(".post_slider .counter-controls__left").click(function () {
    $(this).parents('.post_slider').find('.slick-prev').click();
  });
  $(".post_slider .counter-controls__right").click(function () {
    $(this).parents('.post_slider').find('.slick-next').click();
  });
  $(".forwerts_slider .slide-left").click(function () {
    $(this).parent('.forwerts_slider').find('.slick-prev').click();
  });
  $(".forwerts_slider .slide-right").click(function () {
    $(this).parent('.forwerts_slider').find('.slick-next').click();
  });
  $(".forwerts_slider .counter-controls__left").click(function () {
    $(this).parents('.forwerts_slider').find('.slick-prev').click();
  });
  $(".forwerts_slider .counter-controls__right").click(function () {
    $(this).parents('.forwerts_slider').find('.slick-next').click();
  });
  $(".certificates-wrapper .slide-left").click(function () {
    $(this).parent('.certificates-wrapper').find('.slick-prev').click();
  });
  $(".certificates-wrapper .slide-right").click(function () {
    $(this).parent('.certificates-wrapper').find('.slick-next').click();
  });
  $(".certificates-wrapper .counter-controls__left").click(function () {
    $(this).parents('.certificates-wrapper').find('.slick-prev').click();
  });
  $(".certificates-wrapper .counter-controls__right").click(function () {
    $(this).parents('.certificates-wrapper').find('.slick-next').click();
  });

  function articlesSlider() {
    $(".related").slick({
      dots: false,
      arrows: false,
      infinite: false,
      variableWidth: true,
      // centerMode: true,
      speed: 300,
      slidesToShow: 1
    });
    $(".mindset .articles_block").slick({
      dots: false,
      arrows: false,
      infinite: false,
      variableWidth: true,
      // centerMode: true,
      speed: 300,
      slidesToShow: 1
    });
  }

  if ($(window).width() < 760) {
    $(".related, .mindset .articles_block").on("init", function (event, slick) {});
    articlesSlider();
  }

  jQuery(window).on('resize', function () {
    var viewportWidth = jQuery(window).width();

    if (viewportWidth > 761) {
      $('.related').slick('unslick');
      $(".mindset .articles_block").slick('unslick');
    } else {
      articlesSlider();
    }
  });
  $(".carousel-wrap").each(function () {
    var $number = $(this).data("number");
    var groupCells;

    if ($number == 2) {
      groupCells = 2;
    } else if ($number == 4) {
      groupCells = 4;
    } else {
      groupCells = true;
    }

    var dotsOnMobile = $(this).parents(".new_slider").data('dots_on_mobile');
    var dotsOnTablet = $(this).parents(".new_slider").data('dots_on_tablet');
    var options = {
      pageDots: false,
      imagesLoaded: true,
      adaptiveHeight: true,
      contain: true,
      groupCells: groupCells,
      watchCSS: true,
      cellAlign: 'left'
    };

    if (matchMedia('(min-width:768px) and (max-width: 1024px)').matches) {
      options.pageDots = dotsOnTablet;
    }

    if (matchMedia('(min-width:0px) and (max-width: 767px)').matches) {
      options.pageDots = dotsOnMobile;
    }

    var $carousel = $('.carousel').flickity(options);
    var flkty = $carousel.data('flickity');
    var count = $carousel.find('.carousel-cell').length;
    var countRes = count < 10 ? '0' + count : count;
    $carousel.parent().find('.carousel-numbers').html('<span class="count">01 / ' + countRes + '</span>'); // on slide select

    $carousel.on('select.flickity', function () {
      var currentSlide = flkty.selectedIndex;
      var num = currentSlide < 9 ? '0' + (currentSlide + 1) : currentSlide + 1;
      var count = $carousel.find('.carousel-cell').length;
      var countRes = count < 10 ? '0' + count : count;
      $carousel.parent().find('.carousel-numbers').html('<span class="count">' + num + ' / ' + countRes + '</span>');
    });
  });
});